export const props = {
  name: {
    type: String,
    default: null
  },
  fullscreen: {
    type: [Boolean, String],
    default: 'sm'
  },
  size: {
    type: [String, Object],
    default: 'medium'
  },
  overlay: {
    type: [Boolean, String, Object],
    default: true
  },
  autoClose: {
    type: Boolean,
    default: true
  },
  closeOnClick: {
    type: Boolean,
    default: true
  },
  closeOnEsc: {
    type: Boolean,
    default: true
  },
  appendToBody: {
    type: Boolean,
    default: true
  },
  zIndex: {
    type: [Number, String],
    default: 2001
  }
}

export default { props }
